import React from 'react';
import { Edit2, Calendar, Receipt } from 'lucide-react';

const BottomNav = ({ currentView, setCurrentView }) => {
  const tabs = [
    { id: 'entry', label: 'Entry', icon: Edit2 },
    { id: 'history', label: 'History', icon: Calendar },
    { id: 'expenses', label: 'Expenses', icon: Receipt },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-1px_3px_rgba(16,24,40,0.04)]">
      <div className="flex max-w-2xl mx-auto">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setCurrentView(id)}
            className={`flex-1 flex flex-col items-center gap-1 py-3.5 text-xs font-medium transition-colors ${
              currentView === id ? 'text-accent' : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;
